/**
 * Generated by orval 🍺
 * Do not edit manually.
 * RepeatMD.AdminApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */

export type DataPrivacyRegion = (typeof DataPrivacyRegion)[keyof typeof DataPrivacyRegion];

export const DataPrivacyRegion = {
  NotSensitive: "NotSensitive",
  US: "US",
  EU: "EU",
  Canada: "Canada",
  Brazil: "Brazil",
} as const;
